import { useMemo } from 'react';
import { useQuantityUnitConversionsQuery, useQuantityUnitsQuery, useStockQuery, useProductsQuery } from './useQueries.ts';
import { UnitConversionService } from '../services/UnitConversionService.ts';

export const useUnitConversion = () => {
  const { data: conversions = [] } = useQuantityUnitConversionsQuery();
  const { data: quantityUnits = [] } = useQuantityUnitsQuery();
  const { data: stock = [] } = useStockQuery();
  const { data: products = [] } = useProductsQuery();
  
  const service = useMemo(() => {
    if (conversions.length === 0 || quantityUnits.length === 0 || stock.length === 0 || products.length === 0) {
      return null;
    }
    return new UnitConversionService(conversions, quantityUnits, stock, products);
  }, [conversions, quantityUnits, stock, products]);
  
  return service;
}; 